<!-- DESARROLLLO INICIADO  21/11/2020 wuilmer garcia -->
<template>
  <div>
    <!-- 
            //////////////////////////////////////////////////////
            //                PANTALLA PRINCIPAL                //
            /////////////////////////////////////////////////////   
                                                                                                                                                                                                                                                 -->
    <v-row>
      <v-col cols="12" md="3" lg="2" sm="6">
        <AutocompleteComp v-model="filtro.id_ano_lectivo" textLabel="Año lectivo" :items="listAnoLectivo" item-value="id"
          item-text="nom_anolectivo" @change="eventAnoLectivo" />
      </v-col>

      <v-col cols="12" md="3" lg="2" sm="6">
        <AutocompleteComp textLabel="Curriculo Nacional" v-model="filtro.id_curriculo" :items="listCurriculo"
          item-value="id" item-text="nombre_curriculo" :isDisable="inhabilitarCurriculo" @change="eventCurriculo" />
      </v-col>

      <v-col cols="12" md="3" lg="2" sm="6">
        <AutocompleteComp v-model="filtro.id_nivel" textLabel="Nivel" :items="listNivel" item-value="id_nivel_adm"
          item-text="desc_nivel" @change="filtroNivel" :isDisable="inhabilitarNivel" />
      </v-col>

      <v-col cols="12" md="3" lg="3" sm="6">
        <AutocompleteComp textLabel="Grado" v-model="filtro.id_grado" :items="listGrado" item-value="id"
          item-text="desc_grado" @change="cargarCompCapDes" :isDisable="inhabilitarGrado" />
      </v-col>

      <v-col cols="12" md="3" lg="3" sm="6">
        <AutocompleteComp textLabel="Área" v-model="filtro.id_area" :items="listArea" item-value="id"
          item-text="desc_area" @change="cargarCompCapDes" :isDisable="inhabilitarArea" />
      </v-col>
    </v-row>

    <!-- Item01  PRINCIPAL LISTAR COMPETENCIAS -->
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Leyenda
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                <div class="leyenda-comptencia mx-2">
                </div>
                Competencia
                <div class="leyenda-capacidad mx-2">
                </div>
                Capacidades
                <div class="leyenda-desempeno mx-2">
                </div>
                Desempeños
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-col>


      <v-col cols="12" v-for="(item01, index01) in Datos" :key="index01" class="">


        <v-row>
          <v-col cols="12">
            <v-chip label>
              Nivel:{{ item01.desc_nivel }} | Grado:{{
                item01.desc_grado }} |
              Área: {{ item01.desc_area }}
            </v-chip>
          </v-col>
        </v-row>

        <!--  Item01  RENGLONES DE COMPETENCIAS -->
        <v-row v-for="(item02, index02) in item01.competencias" :key="index02" dense>
          <!-- :value="item02.id_competencia" se modif. en el checkbox para que renderize descomentado -->
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="d-flex text-subtitle-2">
                Competencias
              </v-card-title>
              <v-card-text>
                <v-row class="competencia white--text">
                  <v-col cols="2" class="d-flex justify-center">
                    <v-checkbox dark @change="eventCompetencia($event, index01, item02.id, index02)" class="mx-2">
                    </v-checkbox>
                  </v-col>

                  <v-col cols="10" class="d-flex align-center">
                    <div>
                      <v-icon small color="red"> fas fa-chevron-right fa-lg </v-icon>
                      {{ item02.descripcion }}
                    </div>
                  </v-col>

                  <v-col cols="12" v-if="item02.capacidades" class="">
                    <v-card outlined>
                      <v-card-title class="d-flex text-subtitle-2">
                        Capacidades
                        <v-spacer />
                        <v-btn class="btn_agregar px-2" x-small fab
                          @click="addCapacidad(item01, item02, index01, index02)" :disabled="inhabilitarIcono">
                          <v-icon x-small>fa-plus</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-row class="capacidades white--text" v-for="(item03, index03) in item02.capacidades"
                          :key="index03" dense>
                          <v-col cols="2" class="d-flex justify-center">
                            <!--  event, indexPrincipal, id_competencia_area, indexComp, indexCap  -->
                            <v-checkbox dark :value="item03.id" @change="
                              eventCapacidad(
                                $event,
                                index01,
                                item03.id,
                                index02,
                                index03
                              )
                              ">
                            </v-checkbox>
                          </v-col>

                          <v-col cols="8" class="d-flex align-center">
                            <v-icon color="green"> fas fa-caret-right fa-lg </v-icon>
                            {{ item03.descripcion }}
                          </v-col>

                          <v-col cols="2" class="d-flex justify-end align-center">
                            <v-btn class="btn_editar mr-2" fab x-small @click="
                              editCapacidad(
                                item01,
                                item02,
                                item03,
                                index01,
                                index02
                              )
                              " :disabled="inhabilitarIcono || item03.origen == 0">
                              <v-icon x-small>fa-pencil-alt</v-icon>
                            </v-btn>
                            <v-btn class="btn_eliminar mr-2" fab x-small @click="
                              deleteCapacidad(item03, index01, item02.id, index02)
                              " :disabled="inhabilitarIcono || item03.origen == 0">
                              <v-icon>fa-trash-alt</v-icon>
                            </v-btn>
                          </v-col>

                          <!--
/////////////////////////////////
DESEMPEÑO O INIDICADORES
/////////////////////////////////
                                                                                                                                                                        -->

                          <v-col cols="12" v-if="item03.indicador">
                            <v-card>
                              <v-card-title class="d-flex text-subtitle-2">
                                Desempeños
                                <v-spacer />
                                <v-btn class="btn_agregar mr-2" fab x-small @click="
                                  addIndicador(
                                    item01,
                                    item02,
                                    item03,
                                    index01,
                                    item03.id,
                                    index02,
                                    index03
                                  )
                                  " :disabled="inhabilitarIcono">
                                  <v-icon x-small>fa-plus</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-card-text>
                                <v-row class="desempeno" v-for="(item04, index04) in item03.indicador" :key="index04">
                                  <v-col cols="10" class="d-flex align-center">
                                    <v-icon small color="primary">
                                      fas fa-angle-double-right fa-lg
                                    </v-icon>
                                    {{ item04.descripcion }}
                                  </v-col>

                                  <v-col cols="2" class="d-flex justify-end">
                                    <v-btn class="btn_editar mr-2" fab x-small @click="
                                      editIndicador(
                                        item01,
                                        item02,
                                        item03,
                                        item04,
                                        index01,
                                        item03.id,
                                        index02,
                                        index03
                                      )
                                      " :disabled="inhabilitarIcono || item04.origen == 0
    ">
                                      <v-icon>fa-pencil-alt</v-icon>
                                    </v-btn>
                                    <v-btn class="btn_eliminar mr-2" fab x-small @click="
                                      deleteIndicador(
                                        item04,
                                        index01,
                                        item03.id,
                                        index02,
                                        index03
                                      )
                                      " :disabled="inhabilitarIcono || item04.origen == 0
    ">
                                      <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>

                          </v-col>

                          <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->


                        </v-row>
                      </v-card-text>
                    </v-card>

                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>


          <!--  CAPACIADADES INSERT  v-model= "checkCapacidad" -->



          <!-- Imten03 DETALLE DE CAPACIADADES -->


          <!-- FIN DE CAPACIDADES -->
        </v-row>
      </v-col>
    </v-row>

    <!-- fin de pantalla principal -->

    <!--
                Datos Form Indicadores: <pre>{{form03}}</pre>
             
                Datos Listar: <pre>{{Datos}}</pre>
                Datos Form Desempeño: <pre>{{form03}}</pre>
                Datos Form Competencia: <pre>{{form02}}</pre>
                Datos Listar: <pre>{{Datos}}</pre>
            -->

    <!-- //////////////////////////////////////////////////
        //////////////    CAPACIDADES             /////////////
                                                                                                                                                                                                                                                ///////////////////////////////////////////////////////    -->
    <!-- modal de agregar CAPACIDADES    -->
    <v-form ref="formDatos02" lazy-validation>
      <v-dialog v-model="dialog_capacidad" persistent scrollable max-width="550">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row dense>
              <v-col cols="10">
                {{ form02Title }}
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn fab dark x-small class="btn_style3" @click="dialog_capacidad = false"><v-icon
                    dark>fa-times</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <!--   <label class="font-weight-bold">SELECCIONE</label> -->
              <v-col cols="12" md="6">
                <v-text-field v-model="form02.desc_nivel" label="Nivel" :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form02.desc_grado" label="Grado" :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form02.desc_area" label="Área" :readonly="true"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-textarea v-model="form02.desc_competencia" label="Nombre de la competencia" :rules="[rul.required]"
                  rows="4" :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea v-model="form02.descripcion" label="Nombre de la capacidad" :rules="[rul.required]"
                  rows="4"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_block_style2" dark v-if="this.evento == 'editar'" @click="saveCapacidad(form02.id)">Guardar
              Cambios</v-btn>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'agregar'" @click="saveCapacidad">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar CAPACIDADES -->

    <!-- modal de borrar  CAPACIDADES    -->
    <v-dialog v-model="form02_delete" max-width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row dense>
            CONFIRMAR
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="form02_delete = false"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>
            ¿Está seguro de eliminar este registro
            <v-chip color="yellow font-weight-black">{{ desc_delete }}</v-chip>
            ?
          </h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="form02_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteForm02">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar CAPACIADES -->

    <!-- modal dialogo de confirmación de CAPACIADES --->
    <v-dialog v-model="dialog_confir_cap" max-width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row dense>
            CONFIRMAR
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="
              confirEventCap(true);
            dialog_confir_cap = false;
            ">
              <v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otra capacidad?</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="btn_style3" dark @click="
            confirEventCap(false);
          dialog_confir_cap = false;
          ">No</v-btn>

          <v-btn class="btn_block_style2" dark @click="
            confirEventCap(true);
          dialog_confir_cap = false;
          ">SÍ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal CAPACIDADES-->

    <!--------  END  CAPACIADES  -------->

    <!-- /////////////////////////////////////////////////////
        //////////////    DESEMPEÑO O INDICADORES    /////////////
        //////////////////////////////////////////////////////////    -->

    <!--      MODAL DE AGREGAR INIDICADORES   -->
    <v-form ref="formDatos03" lazy-validation>
      <v-dialog v-model="dialog_indicador" persistent scrollable max-width="1000">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row dense>
              {{ form03Title }}
              <v-spacer />
              <v-btn fab dark x-small class="btn_style3" @click="dialog_indicador = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row dense>
              <!--   <label class="font-weight-bold">SELECCIONE</label> -->
              <v-col cols="12" md="6">
                <v-text-field v-model="form03.desc_nivel" label="Nivel" :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="form03.desc_grado" label="Grado" :readonly="true"></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="form03.desc_area" label="Área" :readonly="true"></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="12">
                <v-textarea v-model="form03.desc_competencia" label="Nombre de la competencia" :rules="[rul.required]"
                  rows="4" :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea v-model="form03.desc_capacidades" label="Nombre de la capacidad" :rules="[rul.required]"
                  rows="4" :readonly="true"></v-textarea>
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea v-model="form03.descripcion" label="Nombre del desempeño" :rules="[rul.required]"
                  rows="4"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_block_style2" dark v-if="this.evento == 'editar'" @click="saveIndicador(form03.id)">Guardar
              Cambios</v-btn>
            <v-btn class="btn_block_style2" dark v-if="this.evento == 'agregar'" @click="saveIndicador">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin de modal agregar INDICADOR O DESEMPEÑO -->

    <!-- modal confirmación de INDICADOR O DESEMPEÑO --->
    <v-dialog v-model="dialog_confir_ind" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row dense>
            CONFIRMAR
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="
              confirEventInd(false);
            dialog_confir_ind = false;
            "><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Desea registrar otro desempeño?</h3>
          <br />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="btn_style3" dark @click="
            confirEventInd(false);
          dialog_confir_ind = false;
          ">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="
            confirEventInd(true);
          dialog_confir_ind = false;
          ">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------fin modal  confirmación DESEMPEÑO O INDICADORES -->

    <!-- modal de borrar DESEMPEÑO O INDICADORES  -->
    <v-dialog v-model="form03_delete" max-width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row dense>
            CONFIRMAR
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="form03_delete = false"><v-icon
                dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>
            ¿Está seguro de eliminar este registro
            <v-chip color="yellow font-weight-black">{{ desc_delete }}</v-chip>
            ?
          </h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="form03_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteForm03">SÍ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrarDESEMPEÑO O INDICADORES -->

    <!-------- END  DESEMPEÑO O INDICADORES   ----------->
  </div>
</template>

<script>
/*
    <v-checkbox v-model="confSubModuloV" :value="item.id"
        class="my-0" color="#388e3c" hide-details>
    </v-checkbox>

*/

import axios from "../../../../helpers/axios";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
// eslint-disable-next-line
import { join } from "path";

export default {
  name: "formAsignarCompetencia",

  props: ["estadoComp", "parametros"],
  components: {
    AutocompleteComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 77, id_modulo: 4 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    Datos: [],
    filtro: {},
    evento: null,

    // datos de los filtros
    listAnoLectivo: [],
    listCurriculo: [],
    listNivel: [],
    listGrado: [],
    listArea: [],

    // CHECK CA
    checkCapacidad: [],
    checkCompetencia: [],
    CheckIndicador: [],

    // inhabilitar Campos

    inhabilitarIcono: true,
    inhabilitarCurriculo: true,
    inhabilitarNivel: true,
    inhabilitarGrado: true,
    inhabilitarArea: true,

    desc_delete: null,

    // MODAL PARA CAPACIDAD
    dialog_capacidad: false,
    form02: {},
    form02Title: null,
    form02_delete: false,
    dialog_confir_cap: false,

    // MODAL PARA INDICADOR O DESEMPEÑO
    dialog_indicador: false,
    form03: {},
    form03Title: null,
    form03_delete: false,
    dialog_confir_ind: false,

    ///////////////////////////////

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  watch: {
    // cada vez que la pregunta cambie desde el componente padre, esta función será ejecutada
    // eslint-disable-next-line
    estadoComp: function (newValor, oldValor) {
      if (this.estadoComp) {
        this.actualizarParamentro();
        this.loadMain();
      } else {
        //this.limpiarFormUsuario()
      }
    },
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- MOSTRAR TODOS LOS REGISTROS    --------
    async loadMain() {
      let respData = '';
      try {
        this.limpiarForm();
        this.inhabilitarCurriculo = false;
        // datos del año lectivo activos del colegio
        respData = await axios.get(
          `/administrativo/anoLectivo/estado/${sessionStorage.id_colegio}`
        );
        this.listAnoLectivo = respData.data;

        // carga el año lectivo
        this.eventAnoLectivo();
      } catch (error) {
        this.setEnviarMens({ tipo: respData.data.messageT, mensaje: `${respData.data.message}`, tiempo: null });
      }
    },

    ////////////////////////////////////////////
    //////////  Filtro de Año Lectivo CORRECTO  /////////
    async eventAnoLectivo() {
      let respData = '';
      try {
        // curriculo activos del colegios
        respData = await axios.get(
          `/administrativo/curriculo/list/cr/colegio/${sessionStorage.id_colegio}/anoLectivo/${sessionStorage.id_ano_lectivo}`
        );
        this.listCurriculo = respData.data;
      } catch (error) {
        this.setEnviarMens({ tipo: respData.data.messageT, mensaje: `${respData.data.mensaje}`, tiempo: null });
      }
    },

    // listar los datos de los curriculo y actualiza el los niveles
    async eventCurriculo() {
      try {
        this.inhabilitarNivel = false;

        // verifica que el año curriculo este activo
        // let valorFiltro = this.listCurriculo

        let valorFiltro = JSON.parse(JSON.stringify(this.listCurriculo));
        let result = valorFiltro.find(
          (element) => (element.id = this.filtro.id_ano_lectivo)
        );
        this.inhabilitarIcono = result.status ? false : true;

        // status
        let params = {
          id_ano_lectivo: this.filtro.id_ano_lectivo,
          id_colegio_adm_nivel: this.filtro.id_colegio,
        };
        let resp = await axios.post(
          `/administrativo/nivel/niveladmin/`,
          params
        );

        let objectNew = JSON.parse(JSON.stringify(resp.data));

        objectNew.unshift({
          id: null,
          id_nivel_adm: null,
          desc_nivel: "Todos",
        });

        this.listNivel = objectNew;
        this.filtro.id_nivel = null;
        this.cargarCompCapDes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // listar los datos principales, de las competencias asociado al curriculo
    // revisar ojo
    async listarCurriculo() {
      try {
        let params02 = { id: null, id_curriculo: null };
        let response02 = await axios.post(
          "manager/curriculo/cr/list/",
          params02
        );
        this.Datos = response02.data;
        //this.Datos         = [];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.Datos = [];

      this.filtro.id_ano_lectivo = null;
      this.filtro.id_curriculo = null;
      this.filtro.id_colegio = this.datoLogin.id_colegio;

      this.inhabilitarCurriculo = true;
      this.inhabilitarNivel = true;
      this.inhabilitarGrado = true;
      this.inhabilitarArea = true;
    },

    // Listar los DATOS principales Capacidades Competencias Desempeño
    async cargarCompCapDes() {
      try {
        let resp = await axios.post(
          `/administrativo/competencia/cs/all/`,
          this.filtro
        );
        this.Datos = resp.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    ///////////////////////////////////////////////////
    //////////  Filtro de nivel   /////////
    async filtroNivel() {
      try {
        this.filtro.id_grado = null;
        this.filtro.id_area = null;
        this.Datos = [];

        // FALTAN LAS VIEW
        // lista los grados y area por nivel por el nivel

        if (this.filtro.id_nivel == null) {
          this.inhabilitarGrado = true;
          this.inhabilitarArea = true;

          this.listGrado = [];
          this.listArea = [];
        } else {
          this.inhabilitarGrado = false;
          this.inhabilitarArea = false;
          let resp = await axios.post(
            `administrativo/competencia/cs/getAreaGradoXNivel/`,
            this.filtro
          );

          let objectGrado = JSON.parse(JSON.stringify(resp.data.Grados));
          let objectArea = JSON.parse(JSON.stringify(resp.data.Areas));

          objectGrado.unshift({
            id: null,
            desc_grado: "Todos",
          });

          objectArea.unshift({
            id: null,
            desc_area: "Todos",
          });

          this.listGrado = objectGrado;
          this.listArea = objectArea;
        }

        this.cargarCompCapDes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //////////////////////////////////////////////////
    /////////          COMPETENCIAS           ////////
    //////////////////////////////////////////////////

    // CHECK DE COMPETENCIAS EVENTO
    //listar las  CAPACIDADES a dar click en una Competencia
    async eventCompetencia(
      event,
      indexPrincipal,
      id_competencia_area,
      indexComp,
      recargar = false
    ) {
      // event: si esta chequeado o NO la competencia (true, false)
      // indexPrincipal:  posicion del elemento del index Principal
      // id_competencia_area:  campo unico de la tabla competencia
      // indexComp: posicion del elemento de la compentencia
      console.log("EVENT", event);
      if (recargar) {
        this.Datos[indexPrincipal].competencias[indexComp].capacidades = [];
      }

      if (event) {
        try {
          let resp = await axios.get(
            `/administrativo/capacidad/listAllCapacidad/${id_competencia_area}`
          );
          console.log(resp.data);
          if (resp.data.length == 0) {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades = [];
          } else {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades =
              resp.data;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
        //check es false
      } else {
        console.log("MACHO");
        this.Datos[indexPrincipal].competencias[indexComp].capacidades = null;
      }
    },

    //------    END COMPETENCIA            --------  //

    //////////////////////////////////////////////////
    /////////          CAPACIDADES            ////////
    //////////////////////////////////////////////////
    async limpiarForm02() {
      this.form02 = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        id: null,
        id_curriculo: "",
        id_competencia_area: "",
        desc_nivel: "",
        desc_grado: "",
        id_capacidad: "",
        descripcion: "",
        indexPrincipal: "",
        indexComp: "",
      };

      this.resetValidationCap();
    },

    //listar las INDICADORES O DESEMPEÑO  a dar click en una Capacidad
    async eventCapacidad(
      event,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      // event si esta checkqueado o NO la capacidad
      console.log("datos de event Capacidad");

      console.log("EVENTO", event);
      console.log("indexPrincipal: " + indexPrincipal);
      console.log("id_capacidad: " + id_capacidad);
      console.log("indesxComp: " + indexComp);
      console.log("indesCap: " + indexCap);

      if (event) {
        console.log("JODER");
        try {
          // Listar los Indicadores o Desempeños
          let params = {
            id_curriculo: this.filtro.id_curriculo,
            id_competencia_area: null,
            id_mgr_capacidad: null,
            id_capacidad,
          };
          var resp = await axios.post(
            `/administrativo/indicador/listInd/`,
            params
          );

          if (resp.data.length == 0) {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = [];
          } else {
            this.Datos[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = resp.data;
          }
          // this.setEnviarMens({tipo:"E", mensaje: `HOLA 01`, tiempo:null})
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          this.Datos[indexPrincipal].competencias[indexComp].capacidades[
            indexCap
          ].indicador = [];
        }

        // Limpia los Indicadores Seleccionado
      } else {
        // this.setEnviarMens({tipo:"E", mensaje: `HOLA 03`, tiempo:null})
        console.log("MACHO");
        this.Datos[indexPrincipal].competencias[indexComp].capacidades[
          indexCap
        ].indicador = null;
      }
    },

    async addCapacidad(competencia, capacidades, indexPrincipal, indexComp) {
      // console.log(`ITEMES COMPETENCIA: ${competencia}`)
      //  console.log(competencia)
      // console.log(`ITEMES CAPACIDADES: ${capacidades}`)
      // console.log(capacidades)
      this.limpiarForm02();

      this.dialog_capacidad = true;
      this.evento = "agregar";
      this.form02Title = "AGREGAR CAPACIDAD";
      this.form02.desc_nivel = competencia.desc_nivel;
      this.form02.desc_grado = competencia.desc_grado;
      this.form02.desc_area = competencia.desc_area;
      this.form02.id_capacidad = capacidades.id_capacidad;
      // ID_COMPETENCIA_AREA
      this.form02.id_curriculo = this.filtro.id_curriculo;
      this.form02.id_competencia_area = capacidades.id;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;
      this.form02.desc_competencia = capacidades.descripcion;
    },

    async editCapacidad(
      itemsPrincipal,
      competencia,
      capacidad,
      indexPrincipal,
      indexComp
    ) {
      //console.log(capacidad)
      this.limpiarForm02();

      this.dialog_capacidad = true;
      this.evento = "editar";
      this.form02Title = "EDITAR CAPACIDAD";
      this.form02.desc_nivel = itemsPrincipal.desc_nivel;
      this.form02.desc_grado = itemsPrincipal.desc_grado;
      this.form02.desc_area = itemsPrincipal.desc_area;
      this.form02.desc_competencia = competencia.descripcion;
      // ID_COMPETENCIA_AREA
      this.form02.id = capacidad.id;
      this.form02.id_curriculo = this.filtro.id_curriculo;
      this.form02.id_competencia_area = capacidad.id_competencia_area;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;

      this.form02.descripcion = capacidad.descripcion;
    },

    async deleteCapacidad(
      items,
      indexPrincipal,
      id_competencia_area,
      indexComp
    ) {
      this.form02_delete = true;
      this.id_delete = items.id;
      this.desc_delete = items.descripcion;
      this.form02.id_curriculo = this.filtro.id_curriculo;
      this.form02.id_competencia_area = id_competencia_area;
      this.form02.indexPrincipal = indexPrincipal;
      this.form02.indexComp = indexComp;
    },

    // Guardar registro PARA CAPACIADES
    async saveCapacidad(id) {
      //console.log(this.form02);
      if (this.$refs.formDatos02.validate()) {
        try {
          if (this.evento == "agregar") {
            await axios.post("/administrativo/capacidad/", {
              datos: this.form02,
            });
            this.setEnviarMens({
              tipo: `S`,
              mensaje: `¡Información creada con éxito!`,
              tiempo: null,
            });
            this.dialog_confir_cap = true;
          }

          if (this.evento == "editar") {
            await axios.put("/administrativo/capacidad/" + id, this.form02);
            this.setEnviarMens({
              tipo: `S`,
              mensaje: `Información actualizada`,
              tiempo: null,
            });
            // this.evento  = null
          }

          this.dialog_capacidad = false;

          // recarga todas las capacidades
          this.eventCompetencia(
            1,
            this.form02.indexPrincipal,
            this.form02.id_competencia_area,
            this.form02.indexComp,
            true
          );
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de Ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    //------------BORRAR Registro (Capacidades) -------------
    async deleteForm02() {
      this.form02_delete = false;
      let respData = '';
      try {
        respData = await axios.delete("/administrativo/capacidad/" + this.id_delete);
        this.dialog = false;
        // recarga todas las capacidades
        this.eventCompetencia(
          1,
          this.form02.indexPrincipal,
          this.form02.id_competencia_area,
          this.form02.indexComp,
          true
        );
        
        
        this.setEnviarMens({
          tipo: respData.data.messageT,
          mensaje: respData.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: respData.data.messageT, mensaje: `${respData.data.message}`, tiempo: null });
      }
    },

    // Evento de Confirmacion de Modal de Capacidades Agregar otra Capacidad
    async confirEventCap(event) {
      // Continuar Ingrsando true
      // alert("confirEventCap")
      if (event) {
        this.form02.descripcion = "";
        this.dialog_capacidad = true;
        this.resetValidationCap();
      } else {
        this.dialog_capacidad = false;
      }
      // actualiza todas las capacidades capacidades

      //console.log("aqui evento de Competencia")
      this.eventCompetencia(
        1,
        this.form02.indexPrincipal,
        this.form02.id_competencia_area,
        this.form02.indexComp
      );
    },

    //  resetear Validcion de los campos capaciades
    resetValidationCap() {
      this.$refs.formDatos02.resetValidation();
    },
    //-----     END  CAPACIDADES          ----////////

    //////////////////////////////////////////////////
    /////////     INIDICADOR  O DESEMPEÑO     ////////
    //////////////////////////////////////////////////
    async limpiarForm03() {
      this.form03 = {
        id_usuario: this.datoLogin.id,
        id_us_ing: this.datoLogin.id,
        id_us_mod: this.datoLogin.id,
        id: null,
        desc_nivel: "",
        desc_grado: "",
        descripcion: "",
        id_capacidad: "",
        id_competencia_area: null,
        indexPrincipal: null,
        indexComp: null,
        indexCap: null,
      };

      this.resetValidationInd();
    },

    async addIndicador(
      itemsPrincipal,
      competencia,
      capacidades,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      //console.log(`ITEMS COMPETENCIA: $itemsPrincipal}`)
      //console.log(itemsPrincipal)
      console.log(`ITEMS CAPACIDADES: ${competencia}`);
      console.log(competencia);
      // console.log(`ITEMS INDICADOR: ${capacidades}`)
      // console.log(capacidades)

      this.limpiarForm03();
      this.dialog_indicador = true;
      this.evento = "agregar";
      this.form03Title = "AGREGAR DESEMPEÑO";
      this.form03.id_curriculo = this.filtro.id_curriculo;

      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_grado = itemsPrincipal.desc_grado;
      this.form03.desc_area = itemsPrincipal.desc_area;
      this.form03.desc_competencia = competencia.descripcion;
      this.form03.desc_capacidades = capacidades.descripcion;
      this.form03.origen = capacidades.origen;
      // origen de capacidad

      // campos para recargar lista
      this.form03.id_competencia_area = competencia.id;
      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;

      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    async editIndicador(
      itemsPrincipal,
      competencia,
      capacidades,
      indicador,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      // this.setEnviarMens({tipo:"W", mensaje: `HOLA Desempeño EDITAR`, tiempo:null})

      this.dialog_indicador = true;
      this.evento = "editar";
      this.form03Title = "EDITAR DESEMPEÑO";
      this.form03.id_curriculo = this.filtro.id_curriculo;

      //console.log(indicador)
      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_grado = itemsPrincipal.desc_grado;
      this.form03.desc_area = itemsPrincipal.desc_area;
      this.form03.desc_nivel = itemsPrincipal.desc_nivel;
      this.form03.desc_competencia = competencia.descripcion;
      this.form03.desc_capacidades = capacidades.descripcion;
      this.form03.origen = capacidades.origen; // origen de capacidad
      this.form03.id = indicador.id;
      this.form03.descripcion = indicador.descripcion;

      // campos para recargar lista
      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;
      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    // Guardar registro para INDICADOR
    async saveIndicador(id) {
      //console.log(this.form03);
      if (this.$refs.formDatos03.validate()) {
        let resData = "";
        try {
          if (this.evento == "agregar") {
            resData = await axios.post("/administrativo/indicador/", {
              datos: this.form03,
            });
            this.dialog_confir_ind = true;
            // ACTUALIZAR INDICADORES O DESEMPEÑO

            this.setEnviarMens({
              tipo: `${resData.data.messageT}`,
              mensaje: `¡Información creada con éxito!`,
              tiempo: null,
            });
          }

          if (this.evento == "editar") {
            resData = await axios.put(
              "/administrativo/indicador/" + id,
              this.form03
            );
            this.dialog_indicador = false;
            this.evento = null;
            this.eventCapacidad(
              1,
              this.form03.indexPrincipal,
              this.form03.id_capacidad,
              this.form03.indexComp,
              this.form03.indexCap
            );
            this.setEnviarMens({
              tipo: `${resData.data.messageT}`,
              mensaje: `Información actualizada`,
              tiempo: null,
            });
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${resData.data.message}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todo los campos requeridos`,
          tiempo: null,
        });
      }
    },

    // Evento de Confirmacion de Modal de Capacidades Agrtegar otra Capacidad
    async confirEventInd(event) {
      // Continuar Ingrsando true
      if (event) {
        this.form03.descripcion = "";
        this.resetValidationInd();
      } else {
        this.dialog_indicador = false;
        this.eventCapacidad(
          1,
          this.form03.indexPrincipal,
          this.form03.id_capacidad,
          this.form03.indexComp,
          this.form03.indexCap
        );
      }
    },

    async deleteIndicador(
      items,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      //console.log(items)
      this.form03_delete = true;
      this.id_delete = items.id;
      this.desc_delete = items.descripcion;

      this.form03.id_capacidad = id_capacidad;
      this.form03.indexPrincipal = indexPrincipal;
      this.form03.indexComp = indexComp;
      this.form03.indexCap = indexCap;
    },

    //------------BORRAR Registro (Capacidades) -------------
    async deleteForm03() {
      let respData = '';
      try {
        respData = await axios.delete(
          "/administrativo/indicador/" + this.id_delete
        );
        this.form03_delete = false;

        // ACTUALIZAR INDICADORES O DESEMPEÑO
        this.eventCapacidad(
          1,
          this.form03.indexPrincipal,
          this.form03.id_capacidad,
          this.form03.indexComp,
          this.form03.indexCap
        );
       
        this.setEnviarMens({
          tipo: respData.data.messageT,
          mensaje: respData.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: respData.data.messageT, mensaje: `${respData.data.message}`, tiempo: null });
      }
    },

    //  resetear Validcion de los campos capaciades
    resetValidationInd() {
      this.$refs.formDatos03.resetValidation();
    },
    //---- END    INIDICADOR  O DESEMPEÑO     -----//
  },
};
</script>

<style scoped>
.ico_competencia {
  color: #e53935 !important;
}

.ico_capacidad {
  color: #388e3c !important;
}

.ico_indicador {
  color: #01579b !important;
}

.head-competencias {
  background: #025f96 !important;
  color: white !important;
}

.head-capacidades {
  background: #0283d0 !important;
  color: white !important;
}

.head-desempenios {
  background: #028fe4 !important;
  color: white !important;
}
</style>
